import { render } from "./ReceiptInfo.vue?vue&type=template&id=0e4228ed&scoped=true"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js"

import "./ReceiptInfo.vue?vue&type=style&index=0&id=0e4228ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4228ed"]])

export default __exports__